var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ResponsesNothingFound } from "@consta/gpn-responses/ResponsesNothingFound";
import { Button } from "@consta/uikit/Button";
import { useNavigate } from "react-router-dom";
import { useErrorStore } from "../../services/stores/errorStore/store";
import styles from "./ErrorPage.module.scss";
var ErrorPage = function () {
    var error = useErrorStore(function (state) { return state.error; });
    var navigate = useNavigate();
    return (_jsx("div", __assign({ className: styles.errorPage }, { children: _jsx(ResponsesNothingFound, { title: "\u041E\u0448\u0438\u0431\u043A\u0430", description: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043E\u0448\u0438\u0431\u043A\u0438: ".concat(error), actions: _jsx(Button, { size: "m", view: "ghost", label: "\u041F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443", onClick: function () { return navigate("/"); } }) }) })));
};
export default ErrorPage;
